export default __webpack_public_path__ + "static/media/protect-asset.fe99a483.png";